import { IAggFunc, IAggFuncParams } from 'ag-grid-community';
import { ScenarioRunByFundDataModel, ScenarioRunDataModel } from '../../../../schemas/ScenarioRun.schema';

export const runAggFuncs: Record<string, IAggFunc<ScenarioRunDataModel | ScenarioRunByFundDataModel>> = {
  partialNumberOfSharesPercentageAggFunc: (
    params: IAggFuncParams<ScenarioRunDataModel | ScenarioRunByFundDataModel>
  ) => {
    const aggData = params.rowNode.aggData;
    if (!aggData) {
      return;
    }
    if (!aggData.partialNumberOfShares) {
      return 0;
    }
    return (
      (aggData.partialNumberOfShares /
        ((aggData.remainingNumberOfSharesHeld ?? 0) + aggData.partialNumberOfShares)) *
      100
    );
  },
  grossMoicAggFunc: (params: IAggFuncParams<ScenarioRunDataModel | ScenarioRunByFundDataModel>) => {
    const aggData = params.rowNode.aggData;
    const scenarioType = params.context.scenarioType;
    if (!aggData || !scenarioType) {
      return;
    }
    // Prefer the backend notional basis (strike × shares for cashless warrants) so a $0-invested
    // warrant position yields a finite MOIC; fall back to the cash-invested denominator otherwise.
    switch (scenarioType) {
      case 'roundOnly': {
        const denominator = aggData.moicCostBasis || aggData.investedAmount;
        if (!denominator) {
          return 0;
        }
        return (aggData.fmv ?? 0) / denominator;
      }
      case 'roundAndExit':
      case 'exitOnly': {
        const denominator = aggData.moicCostBasis || aggData.investedAmount;
        if (!denominator) {
          return 0;
        }
        return (aggData.grossProceeds ?? 0) / denominator;
      }
      case 'partialExit':
      case 'roundAndPartialExit': {
        const denominator = aggData.moicCostBasis || aggData.partialInvestedAmount;
        if (!denominator) {
          return 0;
        }
        return (aggData.grossProceeds ?? 0) / denominator;
      }
      default: {
        return null;
      }
    }
  },
};
